export default __webpack_public_path__ + "db4febe1c14b379a8e0f34e2ed995b25.svg";